import { ExceptionStatus } from '@amzn/aet-dynamo-kit';

export interface RawOutlierContact {
  contactID: string;
  status: string | null;
  exceptionStatus?: ExceptionStatus | null;
  justification?: string | null;
}

export interface RawOutlier {
  userID: string;
  userName: string;
  managerUserName: string;
  category: string;
  relatedContacts: RawOutlierContact[];
  isRepeat: boolean;
}

// To be removed with old outlier code.
export interface Outlier {
  userID: string;
  userName: string;
  category: string;
  relatedContacts: OutlierRelatedContact[];
}

export interface OutlierRelatedContact {
  contactID: string;
  status?: ContactReviewStatusOptions;
}

export enum ContactReviewStatusOptions {
  UNDEFINED = 'UNDEFINED',
  DRAFT = 'DRAFT',
  DELIVERED = 'DELIVERED',
  REVIEWED = 'REVIEWED',
}
